import { PrimeReactProvider } from 'primereact/api';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import './app.css';
import Router from './routes/sections';
import BaseLayout from './layouts/base-layout';
import { printAppStart } from './utils/app-helpers';
import { AuthProvider } from './auth/auth-provider';
import { useScrollToTop } from './hooks/utils/use-scroll-to-top';
import { usePageTracking } from './hooks/custom/use-page-tracking';
import { ErrorProvider } from './components/error/context/error-provider';
import { CookiesProvider } from './components/cookies/context/cookies-provider';
import { ToastProvider } from './components/toast/context/toast-provider';

// ----------------------------------------------------------------------

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

const PageTrackingWrapper = () => {
  usePageTracking();
  return null;
};

printAppStart();

// ----------------------------------------------------------------------

export default function App() {
  useScrollToTop();
  return (
    <PrimeReactProvider>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <ErrorProvider>
            <CookiesProvider>
              <ToastProvider>
                <PageTrackingWrapper />
                <BaseLayout>
                  <Router />
                </BaseLayout>
              </ToastProvider>
            </CookiesProvider>
          </ErrorProvider>
        </AuthProvider>
      </QueryClientProvider>
    </PrimeReactProvider>
  );
}
